// extracted by mini-css-extract-plugin
export default {"game-slider-wrap":"BtwVnYAgmdgQZZGY9sp2","custom-swiper-slider":"TfcMG_52d4kwnHfyWBbA","slider-item":"NZH3tiTNqSbw6Qhs1WFn","slider-item-content-wrap":"aQaxN00lbqEGhoTQYFNA"};